
export const numberOrder = [
    0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24,
    16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
];

export const anglePerSlot = 360 / 37;
 
export const numberAngleMap = {};
numberOrder.forEach((num, index) => {
    numberAngleMap[num] = index * anglePerSlot;
});

export const chips = [
    { value: 10, displayValue: '10', color: "#c20c0c", width:  35, height: 35 },
    { value: 50, displayValue: '50', color: "#fd9e10", width:  35, height: 35 },
    { value: 100, displayValue: '100', color:"#c2460c",width:  35, height: 35 },
    { value: 500, displayValue: '500', color:"#cba013", width: 35, height: 35 },
    { value: 1000, displayValue: '1k', color:"#146b22", width: 35, height: 35 },
    
    { value: 5000, displayValue: '5k', color:"#0f6690", width: 35, height: 35 },
    { value: 10000, displayValue: '10k', color:"#420f62",width:35, height: 35 },
    { value: 25000, displayValue: '25k', color:"#880f6c",width:35, height: 35 },
];

export const blackNumbers = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];